<template name="TrainingDetail">
  <div class="page-training-detail">
    <Top :isDetailPage="false" :trainingId="routeId" @changeVisitListStatus="inviteListShow = true"></Top>
    <main class="main-container container">
      <!-- show info now:  -->
      <article class="main-content">
        <div class="article-header">
          <div class="inner">
            <!-- Nav tabs -->
            <ul class="nav nav-tabs" role="tablist">
              <li v-if="lesson.loadVideo" @click="showVideo = true" :class="showVideo ? 'active' : ''">{{$t('Video')}}</li>
              <li v-if="lesson.loadPPT || lesson.loadPDF" @click="showVideo = false" :class="showVideo ? '' : 'active'">{{$t('Courseware')}}</li>
              <router-link :to="'/external/training/' + routeId + '/0'">
                <i class="iconfont icon-close"></i>
              </router-link>
            </ul>

            <div class="content-handle">
              <!-- Tab panes -->
              <div class="tab-content">
                <div class="media-container" v-if="lesson.loadVideo" v-show="showVideo">
                  <video-player  class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions"
                    >
                  </video-player>
                </div>
                <div class="media-container" v-if="lesson.loadPPT" v-show="!showVideo">
                  <mediaSwiper :swiperImg="lesson.pptUrls" :showVideo="showVideo"></mediaSwiper>
                </div>
                <div class="media-container" v-if="lesson.loadPDF" v-show="!showVideo">
                  <mediaSwiper :swiperImg="lesson.pdfUrls" :showVideo="showVideo"></mediaSwiper>
                </div>
              </div>
              <div class="handle row">
                <div class="col prev">
                  <router-link :to="`/external/trainingDetail/${routeId}/${lesson.lastLessonId}`" v-if="lesson.lastLessonId !== 0">{{$t('Previous')}}</router-link>
                  <span v-else>{{$t('Previous')}}</span>
                </div>
                <div class="col next">
                  <router-link :to="`/external/trainingDetail/${routeId}/${lesson.nextLseeonId}`" v-if="lesson.nextLseeonId !== 0">{{$t('Next')}}</router-link>
                  <span v-else>{{$t('Next')}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="article-content">
          <div class="lesson-name">{{lesson.lessonName}}</div>
          <section v-if="lesson.remark">
            <h2 class="section-title"><i class="iconfont icon-lesson"></i>{{$t('CourseDescription')}}</h2>
            <div class="section-content">
              {{lesson.remark}}
            </div>
          </section>
          <section v-if="lesson.exam">
            <h2 class="section-title"><i class="iconfont icon-test"></i>{{$t('CourseExamination')}}</h2>
            <div class="section-content">
              <ul class="data-list">
                <li>
                  <div class="row">
                    <div class="col-8">
                      <h3 class="title">{{lesson.exam.examName}}</h3>
                      <div class="desc">{{$t('Total')}}{{lesson.exam.questionCount}}{{$t('topic')}}</div>
                    </div>
                    <div class="col-4">
                      <router-link :to="`/external/exam/${routeId}/${lessonId}/${lesson.exam.examId}`" class="btn">{{$t('Start')}}</router-link>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </article>
    </main>
    <footerMenuExternal :trainingId="routeId" :isContactSelectShow="false" :isDetailPage="false" @changeVisitListStatus="inviteListShow = true"></footerMenuExternal>
    <footerExternal :isLoginPage="false"></footerExternal>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
    <transition name="fade">
      <alertModal :modalType="'simple'" :isModalShown="modalTip" :modalTitle="modalTitle" @cancel="closeModal"></alertModal>
    </transition>
  </div>
</template>

<script>
import Top from '@/views/external/top.vue';
import footerExternal from '@/components/footerExternal.vue';
import footerMenuExternal from '@/components/footerMenuExternal.vue';
import mediaSwiper from '@/components/mediaSwiper.vue';

import { checkNested } from '@/utils/utils';
import { getExternalLessonDetail, lessonview } from '@/utils/api';
import alertModal from '@/components/alertModal.vue';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import { videoPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';
import 'vue-video-player/src/custom-theme.css';

export default {
  name: 'TrainingDetail',
  components: {
    Top,
    footerExternal,
    footerMenuExternal,
    Loading,
    mediaSwiper,
    videoPlayer,
    alertModal,
  },
  data() {
    return {
      inviteListShow: false,
      isLoading: false,
      routeId: 0,
      lessonId: 0,
      lesson: {},
      needLearnTime: 60,
      isLearned: false,
      showVideo: true,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: ''
        }],
        poster: '',
        notSupportedMessage: this.$t('FailedVideo'),
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true
        }
      },
      modalTip: false,
      modalTitle: ''
    }
  },
  created() {
    this.routeId = this.$route.params.id;
    this.lessonId = this.$route.params.lessonId;

    this.getLessonDetail();
    this.setLearnTime();
  },
  watch: {
    $route() {
      this.routeId = this.$route.params.id;
      this.lessonId = this.$route.params.lessonId;

      this.getLessonDetail();

      this.needLearnTime = 60;
      this.setLearnTime();
    },
    needLearnTime() {
      if (this.needLearnTime === 0 && !this.isLearned) {
        lessonview(this.routeId, this.lessonId).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            this.isLearned = res.data.content.model;
          }
        });
      }
    },
    showVideo() {
      if (this.$refs.videoPlayer && !this.showVideo) {
        this.$refs.videoPlayer.player.pause();
      }
    },
  },
  methods: {
    getLessonDetail() {
      this.isLoading = true;
      getExternalLessonDetail(this.routeId, this.lessonId).then((res) => {
        this.isLoading = false;
        if (checkNested(res, 'data', 'content', 'model')) {
          if (res.data.content.status === 2) {
            this.modalTip = true;
            this.modalTitle = res.data.content.message;
          } else {
            this.lesson = res.data.content.model;
            this.playerOptions.sources[0].src = this.lesson.videoUrl3;
            this.playerOptions.poster = this.lesson.videoThumbUrl;
            this.showVideo = this.lesson.loadVideo;
          }
        }
      });
    },
    closeModal() {
      this.$router.go(-1);
    },
    setLearnTime() {
      const t = this;
      if (t.needLearnTime > 0) {
        setTimeout(() => {
          t.needLearnTime -= 1;
          t.setLearnTime();
        }, 1000);
      }
    },
  },
};
</script>
<style lang="scss">
.page-training-detail {
  color: #4a4a4a;
  .detail-header {
    box-shadow: 0 0 15px rgba(100, 100, 100, 0.15);
    margin: 0 -500%;
    padding: 0 500%;
    z-index: 12;
  }
  main {
    padding: 20px 0;
  }
  .detail-header .row .header-right .two-link .training {
    position: relative;
    &:after {
      content: '';
      width: 100%;
      height: 3px;
      position: absolute;
      bottom: 0;
      left: 0;
      background: #e42029;
    }
    span,
    i {
      color: #e42029;
    }
  }
  .vjs-custom-skin > .video-js .vjs-play-progress, .vjs-custom-skin > .video-js .vjs-volume-level {
    background-color: #e42029;
  }
  .video-js:hover .vjs-big-play-button, .vjs-custom-skin > .video-js .vjs-big-play-button:focus, .vjs-custom-skin > .video-js .vjs-big-play-button:active {
    background-color: rgba(228,32,41,0.9);
  }
}
</style>
<style scoped lang="scss">
@import '../../scss/variables.scss';
.page-training-detail {
  color: #4a4a4a;
  .page-title  {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
  }
  .main-container {
    padding: 0 15px 90px;
    margin-top: 10px;
  }
  .article-header {
    margin-bottom: 25px;
    padding-top: 20px;
    .media-container {
      margin-bottom: 15px;
    }
    .nav-tabs {
      border-bottom: none;
      position: relative;
      height: 35px;
      li {
        font-size: 18px;
        padding: 5px 25px;
        margin-right: 20px;
        text-align: center;
        &.active {
          color: #e42029;
          font-weight: bold;
          border-bottom: 3px solid #e42029;
        }
      }
    }
    .content-handle {
      box-shadow: 0 7px 15px rgba(100, 100, 100, 0.07);
      padding-bottom: 20px;
    }
    .icon-close {
      position: absolute;
      right: 2px;
      top: 0;
      font-size: 24px;
      display: none;
    }
    .handle {
      font-size: 14px;
      margin-top: 10px;
      a {
        color: #4a4a4a;
        text-decoration: none;
        border-bottom: 1px solid #4a4a4a;
        &:hover {
          text-decoration: none;
        }
      }
      span {
        color: #ccc;
        border-bottom: 1px solid #ccc;
      }
    }
    .prev {
      span,
      a {
        margin-left: 16%;
      }
    }
    .next {
      text-align: right;
      span,
      a {
        margin-right: 16%;
      }
    }
    @include respond-to('sm-max') {
      margin-bottom: 20px;
      padding-top: 0;
      .content-handle {
        box-shadow: none;
        padding: 0;
      }
      .inner {
        box-shadow: 0 7px 15px rgba(100, 100, 100, 0.07);
        margin: 0 -100%;
        padding: 0 100% 15px;
      }
      .icon-close {
        color: #929292;
        display: block;
      }
      .nav-tabs li {
        padding: 5px 10px;
        font-size: 15px;
        margin-right: 5px;
      }
      .tab-content {
        margin-left: -100%;
        margin-right: -100%;
        .media-container {
          width: 100vw;
          margin: 0 auto;
        }
      }
      .prev,
      .next {
        span,
        a {
          margin: 0;
        }
      }
    }
    @include respond-to('ml') {
      margin-bottom: 20px;
      padding-top: 0;
      .content-handle {
        box-shadow: none;
        padding: 0;
      }
      .inner {
        box-shadow: 0 5px 20px rgba(100, 100, 100, 0.07);
        margin: 0 -100%;
        padding: 0 100% 15px;
      }
      .icon-close {
        display: block;
      }
      .nav-tabs li {
        padding: 5px 10px;
        font-size: 15px;
        margin-right: 5px;
      }
      .tab-content {
        margin-left: -100%;
        margin-right: -100%;
        .media-container {
          width: 100vw;
          margin: 0 auto;
        }
      }
      .prev,
      .next {
        span,
        a {
          margin: 0;
        }
      }
    }
  }
  .lesson-name {
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 15px;
  }
  .section-title {
    font-size: 13px;
    font-weight: bold;
    margin-bottom: 14px;
    i {
      font-weight: normal;
      font-size: 14px;
      margin-right: 4px;
    }
  }
  .section-content {
    font-size: 13px;
    margin-bottom: 15px;
    line-height: 1.54;
  }
}
.data-list {
  ul {
    padding: 0;
    list-style: none;
  }
  li {
    list-style: none;
    margin-bottom: 15px;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(100, 100, 100, 0.15);
    padding: 15px;
    & > div {
      padding: 4px 0;
    }
    .title {
      font-size: 15px;
      font-weight: bold;
      margin-bottom: 15px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 15px;
    }
    .desc {
      color: #929292;
      font-size: 12px;
    }
    .btn {
      font-size: 13px;
      color: #e42029;;
      width: 56px;
      text-align: center;
      height: 28px;
      line-height: 28px;
      border-radius: 14px;
      padding: 0;
      border: 1px solid #e42029;
      margin: 10px 24% 0 0;
      @include respond-to('sm-max') {
        margin-right: 0;
      }
    }
    .col-4 {
      text-align: right;
      padding-right: 0;
      @include respond-to('sm-max') {
        padding-right: 15px;
      }
      @include respond-to('ml') {
        padding-right: 15px;
      }
    }
  }
}
</style>
